The upper limit of position openings to return from the start of the list.

Defaults to 10 if `first` is not specified.
Excess position openings will be trimmed from the end of the list.
